import { insert as s, createComponent as n, mergeProps as u, effect as f, className as d, template as w } from "solid-js/web";
import { handleSelectorOptionClick as y } from "../../../node_modules/.pnpm/@rnwonder_simple-datejs@1.0.4/node_modules/@rnwonder/simple-datejs/dist/datePicker.js";
import { Show as h, For as l } from "solid-js";
import { SelectorOptionButton as S } from "../SelectorOptionButton/index.js";
import { defaultSelectorProps as x } from "../SelectorTwo/index.js";
import v from "../SelectorTwoYearOptions/index.js";
import { cn as i } from "../../utils/class.js";
var g = w("<div>");
function T(e) {
  const c = (r, o) => {
    y(r, o, e, () => {
      var a, p, m;
      (a = e.setSelectorTwoProps) == null || a.call(e, x), (p = e.setShowSelectorTwo) == null || p.call(e, !1), (m = e.close) == null || m.call(e);
    });
  };
  return t = g(), s(t, n(h, { get when() {
    return !e.useValueAsName;
  }, get children() {
    var r = g();
    return s(r, n(l, { get each() {
      return e.optionsArray;
    }, children: (o, a) => n(S, u(e, { value: o, index: a, get className() {
      return i(`
                  rn-p-2 
                  rn-text-sm
                `, e.className);
    }, handleOptionClick: c })) })), f(() => d(r, i(`
            date-month-full-size-selector-options-wrapper 
            rn-grid 
            rn-grid-cols-3 
            rn-gap-x-1 
            rn-gap-y-4
          `))), r;
  } }), null), s(t, n(h, { get when() {
    return e.useValueAsName;
  }, get children() {
    return n(l, { get each() {
      var r;
      return (r = e.yearArray) == null ? void 0 : r.call(e);
    }, children: (r) => n(v, u(e, { array: r, handleOptionClick: c })) });
  } }), null), f(() => d(t, i(`
        date-full-size-selector-area
        rn-z-50
        rn-flex
        rn-flex-col
        rn-justify-between
       
        rn-gap-y-4 
        rn-p-2
      `))), t;
  var t;
}
export {
  T as default
};
